import React from "react";
import {theme, styled} from "@reside/ui";
import {Tooltip} from "../../../tooltip";

import {PdfUploadStatus} from "../../../../utils/constants";

type Props = {
  pdfUploadStatus: "PENDING" | "ERROR" | "SUCCESS";
};

const PDF_TOOLTIP_MESSAGES = {
  PENDING: "PDF is being uploaded to PointClickCare.",
  ERROR:
    "PDF upload to PointClickCare Failed. Check Activity Log in Facility Settings for more info.",
  SUCCESS: "PDF is successfully uploaded to PointClickCare.",
};

// TODO DEV-4072: Inline SVGs are a workaround until the ticket is resolved and proper icons are available via @reside/ui
const CloudAlertIcon = ({color}: {color: string}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{color}}
    data-test-id="pdfStatusIcon"
  >
    <path d="M12 12v4" />
    <path d="M12 20h.01" />
    <path d="M8.128 16.949A7 7 0 1 1 15.71 8h1.79a1 1 0 0 1 0 9h-1.642" />
  </svg>
);

const CloudSyncIcon = ({color}: {color: string}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{color}}
    data-test-id="pdfStatusIcon"
  >
    <path d="m17 18-1.535 1.605a5 5 0 0 1-8-1.5" />
    <path d="M17 22v-4h-4" />
    <path d="M20.996 15.251A4.5 4.5 0 0 0 17.495 8h-1.79a7 7 0 1 0-12.709 5.607" />
    <path d="M7 10v4h4" />
    <path d="m7 14 1.535-1.605a5 5 0 0 1 8 1.5" />
  </svg>
);

const CloudCheckIcon = ({color}: {color: string}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{color}}
    data-test-id="pdfStatusIcon"
  >
    <path d="m17 15-5.5 5.5L9 18" />
    <path d="M5.516 16.07A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 3.501 7.327" />
  </svg>
);

export const PdfUploadStatusIcon = ({pdfUploadStatus}: Props) => {
  const isPending = pdfUploadStatus === PdfUploadStatus.PENDING;
  const isSuccess = pdfUploadStatus === PdfUploadStatus.SUCCESS;

  const icon = isPending ? (
    <CloudSyncIcon color={theme.color.gray100} />
  ) : isSuccess ? (
    <CloudCheckIcon color={theme.color.green100} />
  ) : (
    <CloudAlertIcon color={theme.color.deepOrange100} />
  );

  return (
    <StyledTooltip content={PDF_TOOLTIP_MESSAGES[pdfUploadStatus]}>
      {icon}
    </StyledTooltip>
  );
};

const StyledTooltip = styled(Tooltip)`
  cursor: default;
`;
